import {
  AnchoredPanelType,
  FieldSet,
  InputFormSidePanel,
  InputFormSidePanelProps,
  RadioGroup,
  RadioGroupOption,
  SimpleBuilder,
  TextInput,
  TextInputMultilineConfig,
} from "o4a-react";
import * as React from "react";
import { Label, mergeStyleSets } from "@fluentui/react";
import * as Messages from "../../codegen/Messages";
import { mdsBackupDefaultRetentionInDays, MYSQL_BACKUP_TYPES } from "../../helpers/resourceHelper";
import { validateMdsBackupName, validateTagKey } from "../../helpers/validationHelper";
import { IntegerInput } from "../IntegerInput/IntegerInput";

export const enum Fields {
  Name = "name",
  Description = "description",
  BackupType = "backupType",
  RetentionInDays = "retentionInDays",
  FreeformTags = "freeformTags"
}

export interface MysqlBackupCreatePanelProps extends
  Pick<InputFormSidePanelProps, "componentRef" | "onSubmit" | "onClose"> {
  targetId: string;
}

const classNames = mergeStyleSets({
  nameInput: { width: "50%", minWidth: "107px" },
  valueInput: { width: "50%", minWidth: "107px" },
});

export const MysqlBackupCreatePanel = ({
  targetId,
  onSubmit,
  onClose,
  componentRef,
}: MysqlBackupCreatePanelProps): JSX.Element => {
  const backupTypeOptions: RadioGroupOption[] = [
    { id: MYSQL_BACKUP_TYPES.FULL, text: Messages.labels.full() },
    { id: MYSQL_BACKUP_TYPES.INCREMENTAL, text: Messages.labels.incremental() },
  ];

  return (
    <InputFormSidePanel
      anchorId={targetId}
      type={AnchoredPanelType.MEDIUM}
      title={Messages.createNewPanels.mysqlManualBackup.title()}
      onSubmit={onSubmit}
      onClose={onClose}
      componentRef={componentRef}
    >
      <TextInput
        required
        fieldName={Fields.Name}
        label={Messages.labels.name()}
        validator={validateMdsBackupName}
      />
      <TextInput
        fieldName={Fields.Description}
        label={Messages.labels.description()}
        multiline={{ rows: 5 } as TextInputMultilineConfig}
      />
      <RadioGroup
        label={Messages.labels.backupType()}
        defaultValue={MYSQL_BACKUP_TYPES.FULL}
        fieldName={Fields.BackupType}
        options={backupTypeOptions}
      />
      <IntegerInput
        required
        label={Messages.labels.retentionPeriodDays()}
        fieldName={Fields.RetentionInDays}
        defaultValue={mdsBackupDefaultRetentionInDays}
      />
      <FieldSet header={Messages.labels.tags()}>
        <SimpleBuilder fieldName={Fields.FreeformTags}>
          <TextInput
            label={Messages.common.name()}
            fieldName="name"
            className={classNames.nameInput}
            validator={validateTagKey}
          />
          <Label>:</Label>
          <TextInput
            label={Messages.common.value()}
            fieldName="value"
            className={classNames.valueInput}
          />
        </SimpleBuilder>
      </FieldSet>
    </InputFormSidePanel>
  );
};
